import React from 'react';
import { ChartType } from '../../Component/Model/Enum/ChartType';
import { DashboardSectionType } from '../../Component/Model/Enum/DashboardType';
import { ChartFactoryEmployeeEquity } from './ChartFactory.EmployeeEquity';
import { ChartFactoryWSP } from './ChartFactory.WSP';


export interface IChartFactoryProps {
  chartType: ChartType;
  scorecardId: string;
  scorecardTypeId?: string;
  chartOptions: any;
  dashboardType: DashboardSectionType;
  dashboardLevelOnClick?: (chartLabel: string, occupationalLevelIds?: number[]) => void;
  sourceScorecardIds?: string[];
}

export const ChartFactory: React.FC<IChartFactoryProps> = (
  props: IChartFactoryProps
) => {

  switch (props.dashboardType) {
    case DashboardSectionType.ee:
      const employeeEquityChartResult = ChartFactoryEmployeeEquity(props);
      return employeeEquityChartResult;
    case DashboardSectionType.wsp:
      const wspChartResult = ChartFactoryWSP(props);
      return wspChartResult;
    default:
      return <h3>Error: Chart Not defined in Chart Factory</h3>;
  }
};
